import React, {useEffect, useState} from 'react';
import {useTranslation}        from 'react-i18next';
import Dialog                  from '@mui/material/Dialog';
import DialogTitle             from '@mui/material/DialogTitle';
import DialogContent           from '@mui/material/DialogContent';
import Grid                    from '@mui/material/Grid';
import TextField               from '@mui/material/TextField';
import DialogActions           from '@mui/material/DialogActions';
import Button                  from '../../../../inputs/Button';
import {connect}               from 'react-redux';
import {Box}                   from '@mui/material';
import {createShippingFeeZone} from '../../../../../../store/actions/store/ShippingFeeAction';
import FormRequiredField       from '../../../../feeback/FormRequiredField';

const CreateDialog = ({feeId, open, setOpen, creating, create, onCreated}) => {
	const {t} = useTranslation();
	const [name, setName] = useState('');

	const [saveDisabled, setSaveDisabled] = useState(true);

	useEffect(() => {
		setSaveDisabled((name.trim() === ''));
	}, [name, setSaveDisabled]);

	const handleClose = () => {
		setOpen(false);
	};

	const handleCreate = (e) => {
		e.preventDefault();
		create(feeId, {Name: name})
			.then((s) => onCreated(s))
			.then(handleClose);
	};

	return (
        <Dialog
            disableEnforceFocus
            open={open}
            aria-labelledby={t('create_shipping_fee_zone')}
            aria-describedby={t('create_shipping_fee_zone')}
            TransitionProps={{
                onEnter: () => {
                    setName('');
                }
            }}>
            <form onSubmit={handleCreate}>
				<DialogTitle>{t('create_shipping_fee_zone')}</DialogTitle>
				<DialogContent>
					<Box py={2}>
						<Grid container spacing={3}>
							<FormRequiredField/>
							<Grid item xs={12}>
								<TextField
									label={t('shipping_fee_zone_name')}
									fullWidth variant="outlined" value={name}
									required
									disabled={creating}
									onChange={e => setName(e.target.value)}
								/>
							</Grid>
						</Grid>
					</Box>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} disabled={creating}>
						{t('close_btn')}
					</Button>

					<Button color="primary" type="submit" variant="contained"
					        disabled={creating || saveDisabled}
					        loading={creating}>
						{t('create_btn')}
					</Button>
				</DialogActions>
			</form>
        </Dialog>
    );
};
const mapStateToProps = (state) => {
	return {
		creating: state.shippingFee.zoneCreating,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		create: (feeId, data) => dispatch(createShippingFeeZone(feeId, data)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateDialog);